import React, {useMemo} from "react";
import AdminLayout from "@widgets/layout/AdminLayout";
import router, {Route} from "@/routing/Router";
import FeaturedProductsOverview from "@widgets/featuredProducts/overview/FeaturedProductsOverview";

const FeaturedProducts = () => {
    const route: Route = useMemo(() => router.featuredProducts, []);

    return (
        <AdminLayout currentPage={route}>
            <FeaturedProductsOverview route={route}/>
        </AdminLayout>
    );
};

export default FeaturedProducts;